export const DELETED_USER = "DeletedUser";
export const UPDATED_USER = "UpdatedUser";

export const DELETED_CONTACT = "DeletedContact";
export const UPDATED_CONTACT = "UpdatedContact";     

export const DELETED_INVOICE = "DeletedInvoice";
export const CREATED_INVOICE = "CreatedInvoice";

export const DELETED_ORGANISATION = "DeletedOrganisation";
export const UPDATED_ORGANISATION = "UpdatedOrganisation";     

export const DELETED_PHASE = "DeletedPhase";
export const UPDATED_PHASE = "UpdatedPhase";     

export const DELETED_PROJECT = "DeletedProject";
export const UPDATED_PROJECT = "UpdatedProject";     

export const DELETED_PROJECTITEM = "DeletedProjectItem";
export const UPDATED_PROJECTITEM = "UpdatedProjectItem";     

export const DELETED_PROJECTITEMACTIVITY = "DeletedProjectItemActivity";
export const UPDATED_PROJECTITEMACTIVITY = "UpdatedProjectItemActivity";     

export const DELETED_PROJECTITEMINVOICEAMOUNT = "DeletedProjectItemInvoiceAmount";
export const UPDATED_PROJECTITEMINVOICEAMOUNT = "UpdatedProjectItemInvoiceAmount";     

export const DELETED_PROJECTITEMMILESTONE = "DeletedProjectItemMilestone";
export const UPDATED_PROJECTITEMMILESTONE = "UpdatedProjectItemMilestone";     

export const DELETED_PROJECTITEMNOTE = "DeletedProjectItemNote";
export const UPDATED_PROJECTITEMNOTE = "UpdatedProjectItemNote";     

export const DELETED_SITE = "DeletedSite";
export const UPDATED_SITE = "UpdatedSite";

export const DELETED_MILESTONETEMPLATE = "DeletedMilestoneTemplate";
export const UPDATED_MILESTONETEMPLATE = "UpdatedMilestoneTemplate";     

export const DELETED_MILESTONETEMPLATEENTRY = "DeletedMilestoneTemplateEntry";
export const UPDATED_MILESTONETEMPLATEENTRY = "UpdatedMilestoneTemplateEntry";     

export const DELETED_PHASENOTE = "DeletedPhaseNote";
export const UPDATED_PHASENOTE = "UpdatedPhaseNote";   